function applianceDateCommit(isoValue) {
  if (isoValue == null || String(isoValue).trim() === '') {
    return { ok: true, iso: null, display: null };
  }
  const raw = String(isoValue).trim();
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!match) {
    return { ok: false, error: 'Enter a complete date.' };
  }
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (year < 1000 || year > 9999) {
    return { ok: false, error: 'Enter a year from 1000 to 9999.' };
  }
  if (month < 1 || month > 12) {
    return { ok: false, error: 'Enter a valid date.' };
  }
  const utc = new Date(Date.UTC(year, month - 1, day));
  if (
    utc.getUTCFullYear() !== year ||
    utc.getUTCMonth() !== month - 1 ||
    utc.getUTCDate() !== day
  ) {
    return { ok: false, error: 'Enter a valid date.' };
  }
  const display = `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
  return { ok: true, iso: raw, display };
}

module.exports = { applianceDateCommit };
